export const toJson = (res: {
  json: Function,
  [key: string]: any
}) => res.json();